import React, { useEffect, useState, useContext } from "react";
import { getRestaurant } from "../state/restaurantSlice";
import { useDispatch, useSelector } from "react-redux";
import { getCategory } from "../state/categorySlice";
import { Link, useNavigate } from "react-router-dom";
import facebook from "../assets/sosyal/facebook.png";
import instagram from "../assets/sosyal/instagram.png";
import twitterx from "../assets/sosyal/twitterx.png";
import mail from "../assets/sosyal/mail.png";
import down from "../assets/icon/down.png";
import "../styles/firstpage.styles.css";
import link from "../assets/sosyal/link.png";
import info from "../assets/icon/info.png";
import right from "../assets/icon/right.png";
import phone from "../assets/icon/phone.png";
import turkey from "../assets/icon/turkey.png";
import { LanguageContext } from "../context/LanguageContext";
import { useTheme } from "../context/ThemeContext";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { GlobeAltIcon } from "@heroicons/react/24/solid";
import english from "../assets/icon/english.png";
import RatingSection from "../components/RatingSection";
// import background from '../assets/images/piraye.jpg';
import {
  ChevronDownIcon,
  InformationCircleIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/solid";

const FirstPage = ({ id }) => {
  const { language, chooseLanguage } = useContext(LanguageContext);
  const theme = useTheme();
  const navigate = useNavigate();

  const [adresModal, setAdresModal] = useState(false);

  const [languageModal, setLanguageModal] = useState(false);

  const [menuModal, setMenuModal] = useState(false);

  const dispatch = useDispatch();

  const { category } = useSelector((state) => state.category);

  const { restaurant } = useSelector((state) => state.restaurant);
  const [resim1, setResim1] = useState("");
  const [firmLogo, setFirmLogo] = useState("");

  useEffect(() => {
    const data2 = { path: id + "/categoryno.json" };
    const data = { path: id + "/restaurant.json" };
    dispatch(getCategory(data2));
    dispatch(getRestaurant(data));
  }, [dispatch, id]);

  console.log("restaurant", restaurant);

  // Kategorileri dile göre gruplama
  const groupby = category?.reduce((group, item) => {
    const { UP_CATEGORY_TR, UP_CATEGORY_IN } = item;

    // Kullanılacak anahtar: dil Türkçe ise direkt Türkçe; İngilizce ise İngilizce varsa onu, yoksa Türkçeyi kullan
    const groupKey =
      language === "Türkçe"
        ? UP_CATEGORY_TR
        : UP_CATEGORY_IN?.trim() || UP_CATEGORY_TR;

    group[groupKey] = group[groupKey] ?? [];
    group[groupKey].push(item);

    return group;
  }, {});

  console.log(category);
  const url =
    "https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/restaurant_pictures/" +
    id +
    "/";

  useEffect(() => {
    if (id) {
      fetch(url + "1").then((data) => {
        data.text().then((text) => setResim1(text));
      });

      const logoUrl =
        "https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/restaurant_pictures/" +
        id +
        "/";
      fetch(logoUrl + "giris_logo_beyaz")
        .then((data) => data.text())
        .then((text) => setFirmLogo(text))
        .catch((err) => console.error(err));
    }
  }, [id]);

  // Menüyü Gör butonuna tıklayınca çağrılacak fonksiyon
  const handleMenuClick = () => {
    if (groupby) {
      const upperCategories = Object.keys(groupby);
      
      // Eğer üst kategori yoksa veya sadece 1 tane varsa direkt menüye git
      if (upperCategories.length === 0 || upperCategories.length === 1) {
        const firstCategory = upperCategories[0] || "";
        navigate(`/home?id=${id}&selectedCategory=${firstCategory}`);
      } else {
        // Birden fazla üst kategori varsa modal aç
        setMenuModal(true);
      }
    } else {
      setMenuModal(true);
    }
  };

  console.log(resim1);

  return (
    <div className="firstContainer">
      {/* Arka plan resmi - sadece resim varsa göster */}
      {resim1 && (
        <img
          src={resim1}
          alt="bgImage"
          className="object-fill w-full h-full absolute inset-0 z--1 "
        />
      )}
      
      {/* Overlay katman */}
      <div className="absolute top-0 left-0 w-full h-full bg-dark opacity-20"></div>

      {/* Ana içerik */}
      <div className="centered z-20 mt-40" style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
        {firmLogo && (
          <img
            src={firmLogo}
            alt=""
            className="rounded-full w-40 h-40 text-center mb-5"
          />
        )}
        <h3 className="page-title text-white text-center">
          {restaurant[0]?.FIRMA}
        </h3>
        <div
          className="languageContainer tr_eng align-center items-center"
          onClick={() => setLanguageModal(true)}
        >
          <GlobeAltIcon className="w-6 h-6 mr-2 text-white" />
          <a href="#" className="text-white font-bold">
            {language === "Türkçe" ? "Türkçe" : "English"}
          </a>
          <ChevronDownIcon className="w-6 h-6 mr-2 text-white ml-2" />
        </div>
        <div className="menu-container " onClick={handleMenuClick}>
          <button className={`${theme.primary.bg} p-2 text-white rounded-lg`}>
            {language === "Türkçe" ? "Menüyü Gör" : "Go to Menu"}
          </button>
        </div>
      </div>

      {/* Rating Section - MP425 ve MP405 için */}
      <RatingSection id={id} position="top-left" />

      {/* Info butonu */}
      <div
        className="infoContainer z-20"
        onClick={() => setAdresModal(true)}
      >
        <div className="info-1">
          <InformationCircleIcon className="w-6 h-6  text-white" />
          <h6 className="text-white font-bold">
            {language === "Türkçe" ? "Bilgi" : "Info"}
          </h6>
        </div>
        <div className="info-2">
          <ChevronRightIcon className="w-6 h-6 text-white" />
        </div>
      </div>

      {/* Sosyal medya linkleri - sadece resim varsa göster */}
      {resim1 && (
        <div className="bottom-left">
          {restaurant[0]?.INSTAGRAM && (
            <a
              target="_blank"
              href={`https://www.instagram.com/${restaurant[0]?.INSTAGRAM}`}
              className="text-white sosyal"
            >
              <i className="fab fa-instagram "></i>
            </a>
          )}
          {restaurant[0]?.TELEFON && (
            <a
              target="_blank"
              href={`tel:${restaurant[0]?.TELEFON}`}
              className="text-white sosyal"
            >
              <i className="fa-solid fa-phone-volume"></i>
            </a>
          )}
          {restaurant[0]?.FACEBOOK && (
            <a
              target="_blank"
              href={`https://www.facebook.com/${restaurant[0]?.FACEBOOK}`}
              className="text-white sosyal"
            >
              <i className="fab fa-facebook"></i>
            </a>
          )}
          {restaurant[0]?.TWITTER && (
            <a
              target="_blank"
              href={`https://www.twitter.com/${restaurant[0]?.TWITTER}`}
              className="text-white sosyal"
            >
              <i className="fab fa-x-twitter"></i>
            </a>
          )}
          {restaurant[0]?.LINKEDIN && (
            <a
              target="_blank"
              href={`https://www.linkedin.com/in/${restaurant[0]?.LINKEDIN}`}
              className="text-white sosyal"
            >
              <i className="fab fa-linkedin"></i>
            </a>
          )}
          {restaurant[0]?.MAIL && (
            <a
              target="_blank"
              href={`mailto:${restaurant[0]?.MAIL}`}
              className="text-white sosyal"
            >
              <i className="fa-solid fa-envelope"></i>
            </a>
          )}
        </div>
      )}

      {/* Adres Modal */}
      <Modal
        className="my-modal"
        centered
        size="md"
        isOpen={adresModal}
        toggle={() => setAdresModal(!adresModal)}
      >
        <ModalHeader toggle={() => setAdresModal(!adresModal)}>
          <p className="mt-3">{language === "Türkçe" ? "Bilgi" : "Info"}</p>
        </ModalHeader>
        <ModalBody>
          <div className="modal-container">
            <div className="address-body">
              <p className="mt-3">{restaurant[0]?.FIRMA}</p>
            </div>
            <div className="adresContainer">
              <p>{language === "Türkçe" ? "Adres" : "Address"}</p>
              <p className="text-sm">{restaurant[0]?.ADRES}</p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="btn btn-outline-secondary"
            onClick={() => setAdresModal(!adresModal)}
          >
            {language === "Türkçe" ? "Kapat" : "Close"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Dil Modal */}
      <Modal
        className="my-modal"
        centered
        size="md"
        isOpen={languageModal}
        toggle={() => setLanguageModal(!languageModal)}
      >
        <ModalHeader toggle={() => setLanguageModal(!languageModal)}>
          <p className="langTitle mt-3">
            {language === "Türkçe" ? "Dil Seçin" : "Choose Language"}
          </p>
        </ModalHeader>
        <ModalBody>
          <div className="modal-container">
            <div
              className="language-body"
              onClick={() =>
                chooseLanguage("Türkçe") || setLanguageModal(false)
              }
            >
              <img src={turkey} alt="tr" className="turkey-icon" />
              <p className="lang">
                {language === "Türkçe" ? "Türkçe" : "Turkish"}
              </p>
            </div>
            <div
              className="language-body"
              onClick={() =>
                chooseLanguage("English") || setLanguageModal(false)
              }
            >
              <img src={english} alt="en" className="english-icon" />
              <p className="lang">
                {language === "Türkçe" ? "İngilizce" : "English"}
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="btn btn-outline-secondary"
            onClick={() => setLanguageModal(!languageModal)}
          >
            {language === "Türkçe" ? "Kapat" : "Close"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Menü Modal */}
      <Modal
        className="my-modal"
        centered
        size="md"
        isOpen={menuModal}
        toggle={() => setMenuModal(!menuModal)}
      >
        <ModalHeader toggle={() => setMenuModal(!menuModal)}>
          <p className="mt-3">
            {language === "Türkçe" ? "Menü Seçin" : "Choose Menu"}
          </p>
        </ModalHeader>
        <ModalBody>
          <div className="modalmenu-container">
            {groupby && Object.keys(groupby).length > 0 &&
              Object.keys(groupby).map((item, index) => {
                return (
                  <Link key={index} to={`/home?id=${id}&selectedCategory=${item}`}>
                    <div className="border-b d-flex flex-row justify-between items-center">
                      <p className="p-1 mt-3">{item}</p>
                      <img
                        src={right}
                        className="right-logo w-5 h-5"
                        alt="img"
                      />
                    </div>
                  </Link>
                );
              })}
          </div>
        </ModalBody>
        <ModalFooter className="border-0">
          <Button
            color="btn btn-outline-secondary"
            onClick={() => setMenuModal(!menuModal)}
          >
            {language === "Türkçe" ? "Kapat" : "Close"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default FirstPage;
